import { render, staticRenderFns } from "./Nfse.vue?vue&type=template&id=ece36474&scoped=true&"
import script from "./Nfse.vue?vue&type=script&lang=js&"
export * from "./Nfse.vue?vue&type=script&lang=js&"
import style0 from "./Nfse.vue?vue&type=style&index=0&id=ece36474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece36474",
  null
  
)

export default component.exports